import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalStoreShallow } from 'src/store/globalStore';

import { StorageManager } from '@speeki/storage-manager';

import { GetTenantByMsTeamsIdDocument } from '@graphql/generated/graphql';

import { useQueryParam } from '@utils/hooks/useQueryParam';

import { APIService } from '@services/ApiService';
import { AuthService } from '@services/AuthService/AuthService';
import { getPath } from '@services/RouteService/paths';

import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { authVar, isUsingMsTeamsVar } from '@boot/reactiveVariables';

export const useMsTeamsRedirect = () => {
    const { setCompanyInfo } = useGlobalStoreShallow(['setCompanyInfo']);

    const navigate = useNavigate();
    const isLoggedIn = useReactiveVar(authVar).isLoggedIn;

    const [getTenantByMicrosoftId, { called, loading }] = useLazyQuery(
        GetTenantByMsTeamsIdDocument,
        {
            context: {
                globalUrl: true,
            },
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: true,
            onCompleted: ({ tenant: { apiUrl, code, name, uuid } }) => {
                setCompanyInfo({
                    uuid,
                    apiUrl,
                    code,
                    name,
                });
                new APIService().setGraphAPI = apiUrl;
                AuthService.setTenantUuid(uuid);

                navigate(getPath({ path: '/' }));
            },
            onError: () => {
                !isLoggedIn && StorageManager.removeValue('tenantUuid');
            },
        },
    );

    const teamsId = useQueryParam('teamsId');

    useEffect(() => {
        if (!!teamsId) {
            isUsingMsTeamsVar(true);
            void getTenantByMicrosoftId({
                variables: { microsoftTenantId: teamsId },
            });
        }
    }, [teamsId]);

    return { teamsLoading: loading && !called };
};
